import {
  takeLeading, put, select, call,
} from 'redux-saga/effects';
import { config } from '@/config';
import { api } from '@/utils/api';
import agentsFactoryActions from './agentsFactory.actions';
import { AgentsFactoryActionTypes } from './agentsFactory.types';
import logger from '@/utils/logger';
import { setCookie } from '@/utils/Application/cookies';

const { WHMCS_URL } = config;

export const signup = function* signup() {
  const { token } = yield select(state => state.auth);

  const request = {
    url: `${WHMCS_URL}/api/v3/agent-factory/signup`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = yield call(api.whmcs.post, request);
    yield put(agentsFactoryActions.signup.success(response.data));

    setCookie('agent-factory-auth', JSON.stringify(response.data.data));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas signup - method signup', error);
    yield put(agentsFactoryActions.signup.failure(error));
  }
};

function* sagas() {
  yield takeLeading(AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_REQUEST, signup);
}

export default sagas;
